import { createRequest, throwResErrors } from "./requestUtil";

export const geocode = (addressString) => {
	return createRequest()
		.get(`api/trimble_maps/locations?search=${addressString}`)
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
